import { DocumentPackage } from "../types";

// Унифицированная палитра цветов (используем существующие цвета из моков)
const CHIP_COLORS = {
  SUCCESS: "rgba(46, 125, 50, 1)", // Зеленый - принято, подписано
  WARNING: "rgba(242, 175, 45, 1)", // Оранжевый - ожидание, ошибки, не принято
  INFO: "rgba(65, 105, 225, 1)", // Синий - получено, отправлено
  NEUTRAL: "rgba(128, 128, 128, 1)", // Серый - процессы, типы документов
} as const;

const INCOMING_NOTIFICATIONS: DocumentPackage[] = [
  {
    id: "notification-1",
    title: "Получение списка замечаний к набору данных в ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Получено из органа Надзора",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Процесс регистрации ОЖР",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "СПБГН",
        receiver: "Билдокс",
        documentSigned: { date: "15.09.2025", time: "14:30 МСК" },
        letterSent: { date: "15.09.2025", time: "15:00 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "all",
    packages: ["all"],
  },
  {
    id: "notification-2",
    title: "Получение списка замечаний к набору данных ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Не принято системой",
        backgroundColor: CHIP_COLORS.WARNING,
      },
      {
        text: "Процесс регистрации ОЖР",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "СПБГН",
        receiver: "Билдокс",
        documentSigned: { date: "14.09.2025", time: "10:15 МСК" },
        letterSent: { date: "14.09.2025", time: "10:45 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "important",
    packages: ["all", "important"],
  },
  {
    id: "notification-3",
    title: "Получение сведений о регистрации ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Получено из органа Надзора",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Процесс регистрации ОЖР",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "Росреестр",
        receiver: "Билдокс",
        documentSigned: { date: "13.09.2025", time: "16:20 МСК" },
        letterSent: { date: "13.09.2025", time: "16:50 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "all",
    packages: ["all"],
  },
  {
    id: "notification-4",
    title: "Получение сведений о регистрации ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Не принято системой",
        backgroundColor: CHIP_COLORS.WARNING,
      },
      {
        text: "Процесс регистрации ОЖР",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "Росреестр",
        receiver: "Билдокс",
        documentSigned: { date: "12.09.2025", time: "09:30 МСК" },
        letterSent: { date: "12.09.2025", time: "10:00 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "important",
    packages: ["all", "important"],
  },
  {
    id: "notification-5",
    title: "Получение программы проверок от ГСН",
    textNumber: undefined,
    chippers: [
      {
        text: "Получено из органа Надзора",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Программа проверок",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "ГСН",
        receiver: "Билдокс",
        documentSigned: { date: "11.09.2025", time: "11:45 МСК" },
        letterSent: { date: "11.09.2025", time: "12:15 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "all",
    packages: ["all"],
  },
  {
    id: "notification-6",
    title: "Получение программы проверок от ГСН",
    textNumber: undefined,
    chippers: [
      {
        text: "Не принято системой",
        backgroundColor: CHIP_COLORS.WARNING,
      },
      {
        text: "Программа проверок",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "ГСН",
        receiver: "Билдокс",
        documentSigned: { date: "10.09.2025", time: "13:20 МСК" },
        letterSent: { date: "10.09.2025", time: "13:50 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "important",
    packages: ["all", "important"],
  },
  {
    id: "notification-7",
    title: "Получение программы проверок от ГСН",
    textNumber: undefined,
    chippers: [
      {
        text: "Не принято системой",
        backgroundColor: CHIP_COLORS.WARNING,
      },
      {
        text: "Программа проверок",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "ГСН",
        receiver: "Билдокс",
        documentSigned: { date: "09.09.2025", time: "08:10 МСК" },
        letterSent: { date: "09.09.2025", time: "08:40 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "archive",
    packages: ["all", "archive"],
  },
  {
    id: "notification-8",
    title: "Получение приказа о назначении должностных лиц",
    textNumber: undefined,
    chippers: [
      {
        text: "Получено из органа Надзора",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Назначение должностных лиц",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "Минстрой",
        receiver: "Билдокс",
        documentSigned: { date: "08.09.2025", time: "15:25 МСК" },
        letterSent: { date: "08.09.2025", time: "15:55 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "all",
    packages: ["all"],
  },
  {
    id: "notification-9",
    title: "Получение сведений о нарушениях раздела №6 ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Получено из органа Надзора",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Процесс выдачи замечаний",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "Госстройнадзор",
        receiver: "Билдокс",
        documentSigned: { date: "07.09.2025", time: "12:40 МСК" },
        letterSent: { date: "07.09.2025", time: "13:10 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "all",
    packages: ["all"],
  },
  {
    id: "notification-10",
    title: "Получение сведений о нарушениях раздела №6 ОЖР",
    textNumber: "123552",
    chippers: [
      {
        text: "Не принято системой",
        backgroundColor: CHIP_COLORS.WARNING,
      },
      {
        text: "Процесс выдачи замечаний",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "Госстройнадзор",
        receiver: "Билдокс",
        documentSigned: { date: "06.09.2025", time: "17:15 МСК" },
        letterSent: { date: "06.09.2025", time: "17:45 МСК" },
      },
    ],
    variant: "default",
    tab: "incoming",
    status: "important",
    packages: ["all", "important"],
  },
];

const OUTGOING_NOTIFICATIONS: DocumentPackage[] = [
  {
    id: "outgoing-1",
    title: "Отправка титульного листа ОЖР на проверку",
    textNumber: "123552",
    chippers: [
      { text: "Отправлено в орган Надзора", backgroundColor: "rgba(65, 105, 225, 1)" },
      { text: "Процесс регистрации ОЖР", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "15.09.2025", time: "14:30 МСК" }, letterSent: { date: "15.09.2025", time: "15:00 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-2",
    title: "Отправка титульного листа ОЖР на проверку",
    textNumber: "123552",
    chippers: [
      { text: "Отправлено в орган Надзора", backgroundColor: "rgba(65, 105, 225, 1)" },
      { text: "Процесс регистрации ОЖР", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "14.09.2025", time: "10:15 МСК" }, letterSent: { date: "14.09.2025", time: "10:45 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-3",
    title: "Отправка титульного листа ОЖР на проверку",
    textNumber: "123552",
    chippers: [
      { text: "Ошибка взаимодействия", backgroundColor: "rgba(242, 175, 45, 1)" },
      { text: "Процесс регистрации ОЖР", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "13.09.2025", time: "16:20 МСК" }, letterSent: { date: "13.09.2025", time: "16:50 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-4",
    title: "Отправка титульного листа ОЖР на проверку",
    textNumber: "123552",
    chippers: [
      { text: "Не принято органом Надзора", backgroundColor: "rgba(242, 175, 45, 1)" },
      { text: "Процесс регистрации ОЖР", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "12.09.2025", time: "09:30 МСК" }, letterSent: { date: "12.09.2025", time: "10:00 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-5",
    title: "Отправка титульного листа ОЖР на проверку",
    textNumber: "123552",
    chippers: [
      { text: "Принято в органе Надзора", backgroundColor: CHIP_COLORS.SUCCESS },
      { text: "Процесс регистрации ОЖР", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "11.09.2025", time: "11:45 МСК" }, letterSent: { date: "11.09.2025", time: "12:15 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-6",
    title: "Отправка подписанной программы проверок в орган Надзора",
    textNumber: undefined,
    chippers: [
      { text: "Отправлено в орган Надзора", backgroundColor: "rgba(65, 105, 225, 1)" },
      { text: "Программа проверок", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "10.09.2025", time: "13:20 МСК" }, letterSent: { date: "10.09.2025", time: "13:50 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-7",
    title: "Отправка подписанной программы проверок в орган Надзора",
    textNumber: undefined,
    chippers: [
      { text: "Ошибка взаимодействия", backgroundColor: "rgba(242, 175, 45, 1)" },
      { text: "Программа проверок", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "09.09.2025", time: "08:10 МСК" }, letterSent: { date: "09.09.2025", time: "08:40 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-8",
    title: "Отправка подписанной программы проверок в орган Надзора",
    textNumber: undefined,
    chippers: [
      { text: "Не принято органом Надзора", backgroundColor: "rgba(242, 175, 45, 1)" },
      { text: "Программа проверок", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "08.09.2025", time: "15:25 МСК" }, letterSent: { date: "08.09.2025", time: "15:55 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
  {
    id: "outgoing-9",
    title: "Отправка подписанной программы проверок в орган Надзора",
    textNumber: undefined,
    chippers: [
      { text: "Принято в органе Надзора", backgroundColor: CHIP_COLORS.SUCCESS },
      { text: "Программа проверок", backgroundColor: "rgba(128, 128, 128, 1)" },
    ],
    table: [
      { sender: "Билдокс", receiver: "Госстройнадзор", documentSigned: { date: "07.09.2025", time: "12:40 МСК" }, letterSent: { date: "07.09.2025", time: "13:10 МСК" } },
    ],
    variant: "default",
    tab: "outgoing",
    status: "all",
    packages: ["all"],
  },
];

const PROCESSING_NOTIFICATIONS: DocumentPackage[] = [
  {
    id: "processing-1",
    title: "Получение программы проверок",
    textNumber: undefined,
    chippers: [
      {
        text: "Ожидает обработки",
        backgroundColor: CHIP_COLORS.INFO,
      },
      {
        text: "Программа проверок",
        backgroundColor: CHIP_COLORS.NEUTRAL,
      },
    ],
    table: [
      {
        sender: "СПбГСН",
        receiver: "Билдокс",
        documentSigned: { date: "01.01.2025", time: "12:00 МСК" },
        letterSent: { date: "-", time: "-" },
      },
    ],
    variant: "default",
    tab: "processing",
    status: "all",
    packages: ["all"],
  },
];

const ALL_NOTIFICATIONS = [...INCOMING_NOTIFICATIONS, ...OUTGOING_NOTIFICATIONS, ...PROCESSING_NOTIFICATIONS];

export const generateMockPackages = (count: number): DocumentPackage[] => {
  const maxCount = Math.min(count, ALL_NOTIFICATIONS.length);
  return ALL_NOTIFICATIONS.slice(0, maxCount);
};
